import type { TaskAgentPreview, TaskClientPreview, TaskCreatedByPreview } from '@/types/clientTasksApiTypes';

type TaskPerson = TaskAgentPreview | TaskClientPreview | TaskCreatedByPreview;

export function getTaskPersonName(person?: TaskPerson | null): string {
  if (!person) return '';
  if (person.full_name) return person.full_name;

  return [person.first_name, person.last_name].filter(Boolean).join(' ');
}
